<div class="footer">
  <div class="row footer-margin">
    <div class="col-sm-12 links">
      <a class="padding-left-0 font-13-footer white-color font-weight-700"
      href="https://www.honda.com/privacy/connected-product-privacy-notice" target="_blank">
      Vehicle Data Privacy
    </a>
    <a class="white-color">|</a>
    <!-- <a class="white-color">|</a>
      <a class="font-12 white-color font-weight-400" (click)="onLinkClick()"
        href="https://www.honda.com/terms-and-conditions">
        Legal Terms and Conditions
      </a>
      <a class="white-color">|</a> -->

      <a class="font-13-footer white-color font-weight-700" (click)="onLinkClick()"
        href="https://www.honda.com/privacy/terms-and-conditions" target="_blank">
        Site Terms
      </a>
      <a class="white-color">|</a>

      <!-- <a class="font-12 white-color font-weight-400" (click)="onLinkClick()"
        href="https://owners.honda.com/legal/terms-conditions">
        HondaLink Legal Terms
      </a>
      <a class="white-color">|</a>
       -->

      <a class="font-13-footer white-color font-weight-700" (click)="onLinkClick()"
        href="https://www.honda.com/privacy/sms-terms" target="_blank">
        SMS Terms and Conditions
      </a>
      <a class="white-color">|</a>

      <a class="font-13-footer white-color font-weight-700" href="https://www.honda.com/privacy/privacy-notice"
        target="_blank">
        Privacy Notice
      </a>
      <a class="white-color">|</a>

      <!-- <a class="font-12 white-color font-weight-400" (click)="onLinkClick()"
        href="https://crrs.secure.force.com/service/CCPA_Request_W2C?Subject=Do%20Not%20Sell" target="_blank">
        Do Not Sell My Personal Information
      </a> -->
      <a class="font-13-footer white-color font-weight-700" (click)="onLinkClick()"
        href="https://www.honda.com/privacy/your-privacy-choices" target="_blank">
        Your Privacy Choices
      </a>
      <a class="white-color">|</a>
      <!-- <a class="font-12 white-color font-weight-400" (click)="onLinkClick()" href="https://www.honda.com/contact"
        target="_blank">
        Contact Us
      </a> -->
      <a class="font-13-footer white-color font-weight-700" (click)="onLinkClick()" href="https://www.honda.com/-/media/Honda-Homepage/PDF/Proposition-65-Consumer-Website-Statement-072518.pdf" target="_blank">
        Prop 65 Info
      </a>
    </div>



    <!-- <div class="col-sm-12 links" *ngIf="!isAcura">
      <a class="font-12 white-color font-weight-400" (click)="onLinkClick()"
        href="https://www.acura.com/terms-and-conditions" target="_blank">
        Legal Terms and Conditions
      </a>
      <a class="white-color">|</a>
      <a class="font-12 white-color font-weight-400" (click)="onLinkClick()"
        href="https://owners.acura.com/legal/terms-conditions" target="_blank">
        AcuraLink Legal Terms
      </a>
      <a class="white-color">|</a>
      <a class="font-12 white-color font-weight-400"
        href="https://www.honda.com/privacy/connected-product-privacy-policy.pdf" target="_blank">
        Vehicle Data Privacy
      </a>
      <a class="white-color">|</a>

      <a class="font-12 white-color font-weight-400" href="https://www.honda.com/privacy/privacy-policy.pdf"
        target="_blank">
        Privacy Notice
      </a>
      <a class="white-color">|</a>

      <a class="font-12 white-color font-weight-400" (click)="onLinkClick()"
        href="https://crrs.secure.force.com/service/CCPA_Request_W2C?Subject=Do%20Not%20Sell" target="_blank">
        Do Not Sell My Personal Information
      </a>
      <a class="white-color">|</a>
      <a class="font-12 white-color font-weight-400" (click)="onLinkClick()" href="https://www.acura.com/contact-us"
        target="_blank">
        Contact Us
      </a>
    </div>
  </div>-->
  <div class="padding-left-0 row footer-margin">
    <div class="col-12 white-color font-weight-300 font-13-footer">
      We use cookies to improve your experience on this site and show you
      personalized advertising. To find out more, read our <a class="white-color font-weight-700 underline"
        href="https://www.honda.com/privacy/privacy-notice#cookies" target="_blank"> cookie policy. </a>
    </div>
    <div class="padding-left-0 row footer-margin">
      <div class="col-12 white-color font-weight-300 font-13-footer">
        &#169;
        <span class="font-13-footer white-color font-weight-300">{{year}} American Honda Motor Co., Inc.
          All Information Contained Herein Applies to U.S. Products Only. For non-U.S-distributor information
          go to
        </span>
        <a class="white-color font-weight-700 underline" href="https://global.honda" target="_blank">
          world.honda.com</a>
      </div>
    </div>
  </div>
</div> 